module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/19FHYQpBWsSKNqFSWYLnLo-f8c0bb2e49ca8735459bd587d09141cb.jpg";